function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28.6 12.845l-8.678.049a1.49 1.49 0 00-1.481 1.5l.085 15.154a1.49 1.49 0 001.5 1.481l8.678-.049a1.488 1.488 0 001.481-1.5L30.1 14.326a1.491 1.491 0 00-1.5-1.481zm-.046 14.9l-8.418.048-.066-11.657 8.418-.048zM24.253 1.073h1V12.13h-1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M19.837 5.716l-.654-.756 3.451-2.988H6.968L2.47 5.716l-.654-.756L6.595.972h18.723l-5.481 4.744z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M22.976 6.482l-1.333 1.155V4.005L3.849 3.839l1.355-1.122h17.772v3.765z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2.816 18.242V5.927H19.01V12.4a3.113 3.113 0 011-.1V4.927H1.816v14.315h15.552v-1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16.64 15.739a1.415 1.415 0 00-1.167-1.034l-1.367-1.367-2.2-2.194a3 3 0 00.217-.618 2.96 2.96 0 00.077-.67 3 3 0 00-.891-2.135 3.047 3.047 0 00-2.152-.884 3.014 3.014 0 00-.657.073 3.1 3.1 0 00-.613.208l1 1 1 1-.445 1.088-1.088.445-1-1-1-1a3.011 3.011 0 00-.183.575 3.053 3.053 0 00-.064.617 3 3 0 00.892 2.135 3.044 3.044 0 002.151.884 3.081 3.081 0 00.611-.061 3.124 3.124 0 00.569-.174l2.212 2.212 1.31 1.31a1.381 1.381 0 00.045.309 1.414 1.414 0 102.731-.732zm-.6.554l-.009.033a.762.762 0 01-.538.538l-.033.008a.758.758 0 01-.734-.2l-.024-.025a.76.76 0 01-.2-.734l.009-.033a.759.759 0 01.538-.537l.033-.009a.761.761 0 01.734.2l.024.024a.761.761 0 01.202.735z"
})));

var SvgWagonListOnlinemin = function SvgWagonListOnlinemin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWagonListOnlinemin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WagonListOnline.min.8ba94610.svg";
export { ForwardRef as ReactComponent };